module.exports = __webpack_public_path__ + "static/img/instoreImg1.52f8a995.png";